<template>
  <!--客户详情弹窗 穿透显示-->
    <div class="customerInfo">
      <div class="topRow" v-if="editMode">
        <div class="btnsDiv">
          <a-button style="margin-right:10px;" @click="cancelEdit">{{$t('baseVO.cacel')}}</a-button>
          <a-button type="primary" @click="saveEdit" :loading="saveLoading">{{$t('baseVO.save')}}</a-button>
        </div>
      </div>
      <div v-if="editMode" style="margin-bottom: 20px;">
        <add-customer :is-personl='isPersonl' @error="errorEvent" ref="customerModel" :modeType="false" @saveSuccess="saveSuccess" :customerId="customerVO.id"></add-customer>
      </div>
      <div>
        <div class="companyInfo"  v-if="!editMode">
<!--          <div class="companyLogo">-->
<!--            <img v-if="customerVO.logo !='0'" :src="getImageUrl()" alt="">-->
<!--            <img  v-else src="../../../../assets/defulat/company.png"/>-->
<!--          </div>-->
          <div class="infoRightDiv">
            <div style='flex-direction: row;display: flex'>
              <div class="nameRow">
                <div class="companyText" v-text="customerVO.companyName"></div>
              </div>
              <div style='display: flex;margin-left: 20px;margin-top: 8px' >
                <div class="labelText">{{$t('customer.customerModal.companyNameCNTip_1')}}:</div>
                <div class="infoText" v-text="customerVO.companySortNameCn"></div>
              </div>
            </div>
            <div>
              <pt-tag v-if="customerVO.customerTypeStr != '~'" class='tags' v-text="customerVO.customerTypeStr"></pt-tag>
              <pt-tag v-if="customerVO.tradeName != '~'" class='tags' v-text="customerVO.tradeName"></pt-tag>
<!--              <pt-tag v-if="customerVO.relationsStr != '~'" class='tags' v-text="customerVO.relationsStr"></pt-tag>-->
              <pt-tag v-if="customerVO.natureOfCompanyStr != '~'" class='tags' v-text="customerVO.natureOfCompanyStr"></pt-tag>
              <pt-tag v-if="customerVO.source != '0'" class='tags' v-text="$t('customer.customerList.goldPlan')"></pt-tag>
            </div>
<!--            <div class="companyInfoRow">-->
<!--              <div>-->

<!--                <div>-->
<!--                  <div class="labelText">{{$t('customer.customerList.customerType')}}:</div>-->
<!--                  <div class="companyUrl infoText" v-text="customerVO.customerTypeStr">www.blackhills.com</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div>-->
<!--                <div style="margin-bottom: 10px;">-->
<!--                  <div class="labelText">{{$t('customer.customerModal.companyTradeLabel')}}:</div>-->
<!--                  <div class="infoText" v-text="customerVO.tradeName">科技互联网</div>-->
<!--                </div>-->
<!--                &lt;!&ndash;<div style="margin-bottom: 10px;">&ndash;&gt;-->
<!--                  &lt;!&ndash;<div class="labelText">{{$t('customer.customerModal.companyNameENLabel')}}:</div>&ndash;&gt;-->
<!--                  &lt;!&ndash;<div class="infoText" v-text="customerVO.companySortNameEn">GD</div>&ndash;&gt;-->
<!--                &lt;!&ndash;</div>&ndash;&gt;-->
<!--                <div v-if="!hideRelationVisible">-->
<!--                  <div class="labelText">{{$t('customer.customerList.relations')}}:</div>-->
<!--                  <div class="companyUrl infoText" v-text="customerVO.relationsStr">www.blackhills.com</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div>-->
<!--                <div>-->
<!--                  <div class="labelText">{{$t('customer.customerModal.companyPropertyLabel')}}:</div>-->
<!--                  <div class="infoText" v-text="customerVO.natureOfCompanyStr"></div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div @click="editDetail" style="margin-left:auto;" v-if="canEditVisible">
            <pt-icon type="icon-bianji1" style="font-size: 16px;" :title="$t('baseVO.edit')" class="editIcon"></pt-icon>
          </div>
        </div>
        <customer-relation ref='customerRelation' :customerVO="customerVO"></customer-relation>
        <div>
          <div v-if="customerVO && customerVO.linkmanDOList">
            <linkman-table @closeEdit='closeEdit' :is-customer='isCustomer' :linkman-list="customerVO.linkmanDOList" :baseInfo="customerVO" :modeType="1" :showEditButtons="canEditVisible"
                           @editLinkman="editLinkman" :show-detail="showLinkmanDetail" @deleteLinkman="deleteLinkman" @addLinkman="addLinkman"></linkman-table>
          </div>
        </div>
        <invoice :type="1" :id="customerVO.id"></invoice>
      </div>
    </div>
</template>

<script>
  import addCustomer from './addCustomer'
  import invoice from '../../../mine/commission/invoice'
  import customerRelation from './customerRelation'

  export default {
    name: 'customerInfo',
    components:{addCustomer,invoice,customerRelation},
    props:{
      customerVO:{},//客户详情信息
      canEditVisible:{
        type:Boolean,
        default:false,
      },
      hideRelationVisible:{ //详情里不显示客户关系字段
        type: Boolean,
        default:false,
      },
      flashRelation:{
        type: Boolean,
        default:false,
      },
      showLinkmanDetail:{
        type: Boolean,
        default:true,
      },
      isPersonl:false,
      isCustomer:false,
    },
    data(){
      return{
        saveLoading:false,
        linkmanForm: this.$form.createForm(this, {}),
        linkmanListVO:{},
        editVisibleList:[],
        linkmanList:[],
        editMode:false,
      }
    },
    watch:{
      'flashRelation'(){
        this.$refs.customerRelation.init()
      }
    },
    methods:{
      errorEvent(){
        this.saveLoading = false;
      },
      editLinkman(){

      },
      deleteLinkman(){

      },
      addLinkman(){

      },
      flashRelationList(){
        this.$refs.customerRelation.init()
      },
      getImageUrl(){
        let url = this.$util.getFileUrl(this.customerVO.logo);
        return url;
      },
      editDetail(){
        this.editMode = true;
      },
      closeEdit(){
        console.log("this.editMode = closeEdit;")
        this.editMode = false;
      },
      cancelEdit(){
        this.saveLoading = false;
        this.editMode = false;
      },
      saveEdit(){
        this.saveLoading = true;
        this.$refs.customerModel.submit();
      },
      saveSuccess(){
        this.cancelEdit();
        this.$refs.customerRelation.init()
        this.$emit("freshCompanyList");
        this.$emit("freshCompanyDeatil");
      }
    }
  }
</script>

<style scoped lang="less">
  .customerInfo{
    padding: 0 20px;
  }
  .tags{
    background: #EDEDED;
    border-radius: 2px;
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 600;
    margin-right: 15px;
    padding: 2px 5px;
    min-width: 45px;
    text-align: center;
  }
  .topRow{
    height: 50px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
  .companyInfo{
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    background-color: #FAFBFC;
    margin-bottom: 30px;
    padding:20px 15px 20px 30px;
    .companyLogo{
      width: 100px;
      margin-right: 30px;
      img{
        width: 100px;height: 100px
      }
    }
  }
  .infoRightDiv{
    display: flex;
    flex-direction: column;
    width: 100%;
    .nameRow{
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;
      .companyText{
        font-size: 18px;
        color: #333333;
        margin-right: 12px;
        font-weight: bold;
      }
    }
    .companyInfoRow{
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .labelText{
        margin-right: 10px;
      }
    }
    .customerLabelDiv{
      margin-top: 25px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .customerLabel{
      background: #FFFFFF;
      border: 1px solid #EAEAEA;
      border-radius: 4px;
      padding: 4px 8px;
      font-size: 12px;
      color: #333333;
      margin-right: 10px;
    }
  }
  .labelText{
    font-size: 12px;
    color: #999999;
  }
  .infoText{
    font-size: 12px;
    color: #333333;
  }
  .titleRow{
    background: #FAFBFC;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 15px;
    .circleYellow{
      width: 12px;
      height: 12px;
      background: #FABE00;
      border-radius: 50%;
      margin: 0 10px;
    }
    .titleText{
      font-size: 14px;
      color: #333333;
    }
  }
  .viewIconDiv{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    margin-left: auto;
    .viewIcon{
      font-size: 16px;
    }
  }
  .contactDiv{
    padding: 0 16px;
    background: #FAFBFC;
    margin-bottom: 10px;
    .labelRow{
      display: flex;
      flex-direction: row;
      height: 36px;
      align-items: center;
    }
    .contactRow{
      border-top: 1px solid #E7E7E7;
      display: flex;
      flex-direction: row;
      height: 45px;
      .contactIcon{
        font-size: 14px;
        margin-left: 16px;
      }
      .contactButton{
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .contactCol{
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .contactIconDiv{
        background: #FBFBFC;
        width: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        .contactIcon{
          font-size: 36px;
        }
      }
    }
  }
</style>